<section class="section-wrapper">
    <h2 class="cam-heading">Manager & delegation</h2>
  
    <div class="section-context">
      <div class="menu-left-content">
        <app-menu-nav-traveler></app-menu-nav-traveler>
      </div>
      <div class="right-content">
       <router-outlet></router-outlet>
      </div>
    </div>
  </section>
  